module.exports = "body {\n  font-family: 'sans-serif'; }\n"